import { Get } from "../../interceptor/axiosInterceptor";

export const downloadFile = async ({
  route,
  fileName = "file",
  extension = ".csv",
  get,
}) => {
  const { response } = await Get({ route });
  console.log("🚀 ~ responsecsv:", response);

  if (response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}${extension}`);
    document.body.appendChild(link);
    link.click();
  }
};
